var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02679 13.0537H16.4961L11.4853 18.1956C11.0849 18.6065 11.0849 19.2809 11.4853 19.6918C11.8858 20.1027 12.5326 20.1027 12.9331 19.6918L19.6997 12.7481C20.1001 12.3372 20.1001 11.6734 19.6997 11.2624L12.9434 4.3082C12.5429 3.89727 11.896 3.89727 11.4956 4.3082C11.0951 4.71913 11.0951 5.38294 11.4956 5.79388L16.4961 10.9463H5.02679C4.46206 10.9463 4 11.4205 4 12C4 12.5795 4.46206 13.0537 5.02679 13.0537Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.0f42ea14296e92d804c18de8fe424ff3.svg";
export { ForwardRef as ReactComponent };